<template>
    <div class="tranjou-account-cell" :title="accountDescription">
        <account-link :account-no="accountNo" class="text-primary">
            {{ accountNo }}
        </account-link>
        &nbsp;-&nbsp;
        <span v-if="!transactionLine.subAccountUuid">
            {{ accountDescription }}
        </span>
        <sub-account-link v-else-if="transactionLine.subAccountUuid" :uuid="transactionLine.subAccountUuid" class="text-primary">
            <i class="inline-block -mb-[1px]" :class="subAccountIcon"/>
            {{ transactionLine.subAccountName }}
        </sub-account-link>
    </div>
</template>

<script setup lang="ts">
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'
import {computed, PropType} from 'vue'
import {CUSTOMER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import {findAccountByNo} from '@/bookkeeping-account/bookkeepingAccount.service'
import {TransactionLine} from '@/types/transaction/TransactionLine'

const props = defineProps({
    transactionLine: {
        type: Object as PropType<TransactionLine>,
        required: true
    }
})

const accountNo = computed(() => props.transactionLine.accountNo)

const isCustomer = computed(() => accountNo.value === CUSTOMER_ACCOUNT_NO)

const accountDescription = computed(() => {
    if (!accountNo.value) return ''
    return findAccountByNo(accountNo.value)?.name
})

const subAccountIcon = computed(() => {
    if (!props.transactionLine.subAccountUuid) {
        return ''
    }
    return isCustomer.value ? 'i-ph-user' : 'i-ph-factory'
})
</script>

<style scoped>

</style>